import { Redirect } from 'react-router-dom'

export function RedirectToMigrateUniV3() {
  return <Redirect to="/migrate/univ3" />
}
